import {selectProjectAction} from "../../slices/project/selected";
import store from "../../store";

export function onProjectMarkerClick(project, marker, history) {
  if (window.map && window.map._markers) {
    window.map._markers.forEach(marker => marker.remove())
  }
  if (window.map) {
    window.map.flyTo({center: project.location.coordinates, zoom: 15, speed: 2})
  }
  store.dispatch(selectProjectAction({project: project, history: history}))
}